import { Typography } from '@freighthub/silhouette-core'
import { FC, PropsWithChildren } from 'react'
import { useRootStore } from 'service/useRootStore'

type QrSmallButtonFaqProps = {
  category: string
  questions: string[]
}

export const QrSmallButtonFaq: FC<PropsWithChildren<QrSmallButtonFaqProps>> = ({ category, questions, children }) => {
  const { faqService } = useRootStore()

  return (
    <Typography color="primary" component="a" role="button" onClick={() => faqService.show(category, questions)}>
      <small>{children}</small>
    </Typography>
  )
}
